module.exports = __webpack_public_path__ + "static/media/venue.a15d7c4f.png";